module.exports = __webpack_public_path__ + "static/media/ypsiParkBridge.0b9c7c9d.jpg";